//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            items: [
                {
                    title: 'Hamburguesa clasica',
                    subtitle: 'Especial de la casa',
                    description:
                        'Deliciosa carne angus hecha a la parrilla, con cebolla, tomate, lechuga, salsa de la casa y pan artesanal.',
                    category: 'Hamburguesas',
                    pic: null,
                    availableDays: [5, 6],
                    price: 6.75,
                    active: true,
                },
                {
                    title: 'Hotdog Hawainano',
                    active: false,
                },
                {
                    title: 'Alitas',
                    active: true,
                },
            ],
        }
    },
}
